import { useDispatch } from "react-redux";
import { AppDispatch } from "@/store";
import { useCallback } from "react";
import { changePlan } from "@/store/modules/Subscriptions/thunks";

const useChangePlan = () => {
  const dispatch: AppDispatch = useDispatch();

  const handleChangePlan = useCallback(
    (
      clientSubscriptionId: string,
      subscriptionId: string,
      clientId: string,
    ) => {
      return dispatch(
        changePlan({ clientSubscriptionId, subscriptionId, clientId }),
      );
    },
    [dispatch],
  );

  return { handleChangePlan };
};

export default useChangePlan;
